import { useIsMobile } from '../../../hooks/useIsMobile';

/**
 * Viewport below which the customers table swaps its column layout for the
 * stacked mobile one. Shared by every component that has to agree on which
 * layout is on screen — the Table settings cog has exactly one home at a time,
 * so the tab view and the table must resolve the same breakpoint.
 */
export const useIsMobileTableLayout = (): { isMobile: boolean } =>
  useIsMobile({ maxWidth: 1024 });
